export const defaultConfig = {
//Apis Urls
 //baseAPIUrl:"https://shutterdev.azurewebsites.net/api/",
baseAPIUrl:"https://shutteruat.azurewebsites.net/api/",
//baseAPIUrl:"https://shtteruat.btprojects.in/apis/api/",
  //Currency sign symbol
  currencySign:"$",
};



